var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-4", staticStyle: { width: "100%" } },
    [
      _c(
        "ContentLoader",
        { attrs: { primaryColor: _vm.dtPalette["grey-3"] } },
        [
          _c("rect", {
            attrs: {
              x: "0",
              y: "0",
              rx: "2",
              ry: "2",
              width: "48",
              height: "5"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "55",
              y: "0",
              rx: "2",
              ry: "2",
              width: "48",
              height: "5"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88b0b2cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88b0b2cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/loaders/ticket-list-texts-loader/template.html
// module id = null
// module chunks = 